import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { Modal } from 'antd';
import Select from 'react-select';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import { useDispatch, useSelector } from 'react-redux';
import { getCatalogItems} from 'store/actions';

const CreateCheckList = ({ visible, handleClose, initialData = '', onSubmit ,id}) => {
    const [catalogueOptions, setCatalogueOptions] = useState([]);
    const dispatch = useDispatch();
    const catalogues = useSelector(state => state.Catalog.catalogItems);

    // useEffect(() => {
    //     // Fetch catalogues data for the select dropdown
    //     dispatch(getCatalogItems());
    // }, [dispatch]);

    // useEffect(() => {
    //     if (catalogues?.Data?.length > 0) {
    //         setCatalogueOptions(
    //             catalogues.Data.map(catalogue => ({
    //                 value: catalogue.catalogueId,
    //                 label: catalogue.itemName,
    //             }))
    //         );
    //     }
    // }, [catalogues]);

    const formik = useFormik({
        enableReinitialize: true,
        initialValues: {
            catalogueId: initialData?.catalogueId || '',
            checklistItem: initialData?.checklistItem || '',
            isMandatory: initialData?.isMandatory || 0,
        },
        validationSchema: Yup.object({
            checklistItem: Yup.string().required('Checklist Item is required'),
            isMandatory: Yup.boolean().required('Mandatory field is required'),
        }),
        onSubmit: (values, { resetForm }) => {
            const formattedValues = {
                ...values,
                isMandatory: values.isMandatory ? 1 : 0,
            };
            if (initialData?.checklistItem) {
                onSubmit({
                    sp: "usp_UpdateChecklist",
                    ...formattedValues,
                    catalogueId:id,
                    checklistId: initialData?.checklistId,
                });
            } else {
                onSubmit({
                    sp: "usp_InsertChecklist",
                    ...formattedValues,
                    catalogueId:id,
                });
            }
            onClose();
        },
    });

    const onClose = () => {
        formik.resetForm();
        handleClose();
    };

    return (
        <Modal
            title={initialData ? "Edit Checklist Item" : "Create New Checklist Item"}
            visible={visible}
            onCancel={onClose}
            footer={null}
            destroyOnClose
            centered
            className='custom-modal-header p-0'
            width={600}
            maskClosable={false}
        >
            <form onSubmit={formik.handleSubmit}>
                <div role="document">
                    <div className="row g-3">
                        <div className="col-md-12">
                            <label className="form-label fs-7">Checklist Item</label> <span className='text-danger'>*</span>
                            <input
                                type="text"
                                className="form-control form-control-md form-control-solid fs-7 bg-body-secondary"
                                placeholder="Enter checklist item"
                                name="checklistItem"
                                value={formik.values.checklistItem}
                                onChange={formik.handleChange}
                            />
                            {formik.touched.checklistItem && formik.errors.checklistItem && (
                                <span style={{ color: 'red' }} role="alert">{formik.errors.checklistItem}</span>
                            )}
                        </div>

                        <div className="col-md-12 d-flex align-items-center">
                            <label className="form-label fs-7">Is Mandatory</label> <span className='text-danger'>*</span>
                            <input
                                type="checkbox"
                                name="isMandatory"
                                className='ms-2'
                                style={{marginBottom:"3px"}}
                                checked={formik.values.isMandatory}
                                onChange={(e) => formik.setFieldValue('isMandatory', e.target.checked ? 1 : 0)}
                            />
                            {formik.touched.isMandatory && formik.errors.isMandatory && (
                                <span style={{ color: 'red' }} role="alert">{formik.errors.isMandatory}</span>
                            )}
                        </div>
                    </div>

                    <div className="modal-footer mt-3">
                        <button type="button" className="btn btn-light" onClick={onClose}>
                            Close
                        </button>
                        <button type="submit" className="btn btn-primary ms-3">
                            {initialData ? "Update" : "Add"}
                        </button>
                    </div>
                </div>
            </form>
        </Modal>
    );
};


export default CreateCheckList;
